/**
 * Project: Academy V2
 * File: MultipleChoiceIcon.tsx
 * Author: Colopi Salvatore
 * Author URI: https://salvatorecolopi.com
 * Created: Tue Jun 04 2024 at 19:39:39
 *
 * Copyright (c) 2024 Edusogno. All rights reserved.
 */

import React from "react";

interface MultipleChoiceIconProps extends React.SVGAttributes<SVGElement> {
  color?: string;
}

const MultipleChoiceIcon: React.FC<MultipleChoiceIconProps> = ({ color = "#8065C9", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.914 1h10.75v10.75h-10.75zM18.914 18.916h10.75v10.75h-10.75zM10.645 4.117a9.644 9.644 0 1 0 0 19.29"
    />
    <path
      d="m8.055 26.344 4.066-2.315-2.315-4.066"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MultipleChoiceIcon;
